import {
  CLEAR_LIBRARY,
  REMOVE_LIBRARY_ITEM,
  SET_LIBRARY_LIST,
  SET_LIBRARY_LIST_CONFIG,
  SET_MORE_LIBRARY_POSTS,
  SET_LIBRARY_NOTE,
} from '../../constants';
import { IReduxAction } from '../../interfaces';

export interface ILibraryListConfig {
  search: string;
  authorSearch: string;
  filter: string;
  sort: string;
  pagination: {
    limit: number,
    lastItem: object | null,
  };
  moreItems: true;
}

interface ILibararyState {
  loaded: boolean;
  list: object[];
  selected: object | null;
  listConfig: ILibraryListConfig;
}

const initState: ILibararyState = {
  loaded: false,
  list: [],
  selected: null,
  listConfig: {
    search: '',
    authorSearch: '',
    filter: 'all',
    sort: 'addedOn-descend',
    pagination: {
      limit: 25,
      lastItem: null,
    },
    moreItems: true,
  },
};

export function libraryReducer(state = initState, action: IReduxAction) {
  switch (action.type) {
    case CLEAR_LIBRARY:
      return initState;

    case SET_LIBRARY_LIST:
      return {
        ...state,
        loaded: true,
        list: action.payload.posts,
        listConfig: {
          ...state.listConfig,
          pagination: {
            ...state.listConfig.pagination,
            lastItem: action.payload.lastItem,
          },
          moreItems: !(action.payload.posts.length < state.listConfig.pagination.limit),
        },
      };

    case SET_MORE_LIBRARY_POSTS:
      return {
        ...state,
        list: [
          ...state.list,
          ...action.payload.posts,
        ],
        listConfig: {
          ...state.listConfig,
          pagination: {
            ...state.listConfig.pagination,
            lastItem: action.payload.lastItem,
          },
          moreItems: !(action.payload.posts.length < state.listConfig.pagination.limit),
        },
      };

    case SET_LIBRARY_LIST_CONFIG:
      return {
        ...state,
        loaded: false,
        listConfig: action.payload,
      };

    case SET_LIBRARY_NOTE:
      console.log('payload', action.payload);
      const posts = state.list
        .map((item: any) => {
          if (item.id === action.payload.id) {
            item.note = action.payload;
          }

          return item;
        });

      return {
        ...state,
        list: [
          ...posts,
        ],
      };

    case REMOVE_LIBRARY_ITEM:
      return {
        ...state,
        list: state.list.filter((item: any) => item.id !== action.payload),
      };

    default:
      return state;
  }
}
